import { Card } from "primereact/card";
import { deleteEMPById } from "../../../services/clearing/emps";
import DeleteWithPopup from "../../components/DeleteWithPopup";

type DeleteEMPSectionProps = {
  mandantName: string;
};

export const DeleteEMPSection = ({ mandantName }: DeleteEMPSectionProps) => {
  return (
    <Card className="p-2 my-4">
      <section className="grid w-full h-full">
        <section className="col-9 flex flex-column">
          <h3 className="text-3xl text-red-600 font-semibold">
            Delete {mandantName}
          </h3>
          <p className="text-md">
            This action is permanent and cannot be undone.
          </p>
        </section>

        <div className="col-3 flex flex-column justify-content-center">
          <DeleteWithPopup
            label="Delete"
            onDelete={() => deleteEMPById(mandantName)}
            redirectTo={"/customers/emps"}
            buttonHeight="3rem"
            buttonWidth="100%"
          />
        </div>
      </section>
    </Card>
  );
};
